import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { customerSelectorStyles } from "@insite/content-library/Components/CustomerSelector";
import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { addressBookPaginationStyles as paginationStyles } from "@insite/content-library/Widgets/Addresses/AddressBookPagination";
import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { billingAddressStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsBillingAddress";
import { shippingAddressStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsShippingAddress";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { headerStyles as myListHeaderStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { headerStyles as myListDetailsHeaderStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Users from "@insite/mobius/Icons/Users";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

addressBookStyles.addressHeaderGridItem = {
    css: css`
        flex-basis: 100%;
        max-width: 100%;
        [class^="FormInputWrapper"] {
            input {
                padding: 12px 30px 12px 10px !important;
                word-wrap: break-word;
                word-break: break-all;
            }
            [class^="IconWrapper"] {
                background-color: #fff;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        // [class^="GridItemStyle"] {
                        //     &:first-of-type {
                        //         max-width: calc(100% - 50px);
                        //         flex-basis: calc(100% - 50px);
                        //     }

                        //     &:nth-of-type(2) {
                        //         max-width: 50px;
                        //         flex-basis: 50px;
                        //     }
                        // }
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

currentBillingAddressStyles.editLink = {
    css: css`
        display: none;
        span {
            line-height: 32px;
        }
    `,
};

currentShippingAddressStyles.editLink = {
    css: css`
        display: none;
        span {
            line-height: 32px;
        }
    `,
};

productListStyles.container = {
    css: css`
        [data-test-selector="addToCart"] span {
            font-size: 15px;
            font-weight: bold;
        }
    `,
};

productListLineStyles.selectedCheckboxHidden = { below: undefined };

productListLineStyles.lineInnerContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        position: relative;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

productListLineStyles.overflowMenuGridItem = {
    css: css`
        display: none;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: block;
                        position: absolute;
                        right: 20px;
                        top: -62px;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

actionStyles.buttonWrapper = {
    css: css`
        ul {
            max-height: 300px;
        }
    `,
};

createListButtonStyles.createListButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin-bottom: 15px;
                    `,
                ],
                "max",
            )}
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    css: css`
        background: transparent;
        border: 0;
        padding: 0;
        color: #2e64b0;
        &:hover {
            background: transparent;
            color: #20467b;
        }
        span {
            font-size: 13px;
            font-weight: normal;
        }
    `,
};

signInResetPasswordFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: initial;
    `,
};

signInResetPasswordFormStyles.sendButton = {
    css: css`
        margin-left: auto;
    `,
};

myListsDetailsOptionsStyles.uploadItemsModal = {
    sizeVariant: "large",
    cssOverrides: {
        modalTitle: css`
            padding: 10px 30px;
            border-bottom: 3px solid #ef3742;
            background: #fafafa;
        `,
        modalContent: css`
            padding: 20px 30px;
        `,
    },
};

signInExistingAccountStyles.userNameGridItem = {
    width: 12,
    css: css`
        > div[class^="FormFieldStyle"] {
            > label::after {
                content: " (email address)";
                font-weight: 100;
            }
        }
    `,
};

headerStyles.buttonSet = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 4, 3, 3],
};

headerStyles.titleWrapper = {
    width: [10, 10, 8, 9, 9],
};

headerStyles.cancelButton = {
    variant: "secondary",
};

paginationStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            div[class^="FormInputWrapper"] {
                padding-top: 3px;
                select {
                    border-radius: 100px;
                    height: 25px;
                    outline: none;
                    &:focus {
                        border: 2px solid #808080;
                        border-radius: 100px;
                        padding: 0 10px 0 10px;
                    }
                }
                span[class^="IconWrapper"] {
                    height: 26px !important;
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
            ul li {
                button {
                    max-width: 30px;
                    span {
                        font-size: 12px;
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            min-height: 20px;
            padding: 0px;
            border-radius: 50%;
        `,
    },
};

addCardButtonStyles.addCardButton = {
    color: "primary",
};

customerCardStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 100%;
        > button {
            width: 110px;
        }
    `,
};
const linkTextStyles: TypographyPresentationProps = {
    color: "#ccc",
};
customerSelectorStyles.customerCardSelected = {
    address: {
        attentionText: linkTextStyles,
        customerNameText: linkTextStyles,
        companyNameText: linkTextStyles,
        address1Text: linkTextStyles,
        address2Text: linkTextStyles,
        address3Text: linkTextStyles,
        address4Text: linkTextStyles,
        cityStatePostalCodeText: linkTextStyles,
        countryText: linkTextStyles,
        phoneText: linkTextStyles,
        emailText: linkTextStyles,
        faxText: linkTextStyles,
    },
};

myListHeaderStyles.leftBottomGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};

myListDetailsHeaderStyles.sharingStatus = {
    statusText: {
        css: css`
            display: flex;
            align-items: center;
            padding-right: 30px;
            @media print {
                display: inline-block;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 10px 0;
                            [data-id="tooltipContainer"] {
                                width: 250px;
                                right: auto !important;
                                left: 60px !important;
                                &:after {
                                    content: "";
                                    right: auto !important;
                                    left: 60px !important;
                                }
                            }
                        `,
                        css`
                            margin: 10px 0;
                            [data-id="tooltipContainer"] {
                                width: 250px;
                                right: auto !important;
                                left: 60px !important;
                                &:after {
                                    content: "";
                                    right: auto !important;
                                    left: 60px !important;
                                }
                            }
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

myListDetailsHeaderStyles.infoGridItem = {
    width: 12,
    css: css`
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
            margin-bottom: 10px !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
};
productSelectorStyles.searchGridItem = {
    width: [12, 12, 4, 4, 4],
};
productSelectorStyles.unitOfMeasureGridItem = {
    width: [9, 9, 2, 3, 3],
};

productSelectorStyles.qtyGridItem = {
    width: [6, 6, 3, 2, 2],
    css: css`
        [class^="FormFieldStyle"] {
            background-color: #e3e3e3;
            flex-direction: row;
            align-items: center;
            padding: 5px;
            flex-basis: 70% !important;
            max-width: 70% !important;
            label {
                position: static !important;
                background: transparent !important;
                font-weight: normal;
                font-size: 12px;
                padding: 6px;
                width: auto !important;
                white-space: nowrap;
            }
            [class^="FormInputWrapper"] {
                margin: 0;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            /* Firefox */
            input[type="number"] {
                -moz-appearance: textfield;
            }
            input {
                height: 30px;
                border-radius: 4px;
                text-align: center;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
            }
        }
    `,
};

wishListSharingStatusStyles.statusText = {
    css: css`
        display: flex;
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        [data-id="tooltipContainer"] {
                            right: auto !important;
                            left: 30px !important;
                            &:after {
                                content: "";
                                right: auto !important;
                                left: 90px !important;
                            }
                        }
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    css: css`
        margin-right: 5px;
        color: #2e64b0;
    `,
};

savedOrderListTableStyles.orderDateHeader = {
    css: css`
        button {
            width: 80%;
        }
    `,
};

savedOrderListTableStyles.shipToLabelHeader = {
    css: css`
        button {
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 50%;
                        `,
                        null,
                        css`
                            width: 90%;
                        `,
                        css`
                            width: 70%;
                        `,
                        css`
                            width: 50%;
                        `,
                    ],
                    "min",
                )}
        }
    `,
};

assignBudgetsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 50%;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

billingAddressStyles.titleText = {
    variant: "h6",
    as: "h2",
    css: css`
        font-size: 20px;
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};

shippingAddressStyles.titleText = {
    variant: "h6",
    as: "h2",
    css: css`
        font-size: 20px;
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};
